import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { FeedbackForm } from "@/components/FeedbackForm";
import { ArrowLeft } from "lucide-react";

export default function HjalpPublik() {
  return (
    <div className="hamn-bg min-h-screen">
      <header className="sticky top-0 z-30 border-b border-border bg-white/90 backdrop-blur-xl">
        <div className="mx-auto max-w-3xl px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="hjalp-home-link">
            <img src="/hamn-logo.png" alt="HAMN CV Studio" className="h-9 w-9 rounded-lg object-cover" />
            <div className="font-head font-bold text-primary">HAMN CV Studio</div>
          </Link>
          <Link to="/" className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1.5" data-testid="hjalp-back-link">
            <ArrowLeft className="h-4 w-4" /> Till startsidan
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-2xl px-4 py-10 md:py-16">
        <h1 className="font-head font-bold text-3xl sm:text-4xl text-primary mb-2">Hjälp & feedback</h1>
        <p className="text-muted-foreground mb-8 max-w-xl">
          Har du en fråga innan du kommer igång, en idé eller något som strular? Skriv till oss – du behöver inte vara inloggad.
        </p>
        <Card className="rounded-2xl border-border p-6">
          <FeedbackForm showContactFields={true} />
        </Card>
        <p className="text-xs text-muted-foreground mt-4">
          Uppgifter du skickar behandlas enligt vår{" "}
          <Link to="/integritetspolicy" className="text-primary underline underline-offset-2" data-testid="hjalp-policy-link">integritetspolicy</Link>.
        </p>
      </main>
    </div>
  );
}
